import { EmptyState } from '@xing-com/crate-entity-pages-common';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { JOBMANAGER_URL, XING_JOBS_URL } from '../../config/urls';

type JobsEmptyStateProps = { statusCode?: 404 | undefined };

export const JobsEmptyState: React.FC<JobsEmptyStateProps> = ({
  statusCode,
}) => {
  const { pageContext } = usePageContext();
  const isEditor = pageContext.isEditor;

  return (
    <EmptyState
      headlineCopyKey={
        isEditor
          ? 'EP_JOBS_EMPTYSTATE_HEADER'
          : 'EP_JOBS_PUBLIC_EMPTYSTATE_HEADER'
      }
      textCopyKey={
        isEditor ? 'EP_JOBS_EMPTYSTATE_BODY' : 'EP_JOBS_PUBLIC_EMPTYSTATE_BODY'
      }
      statusCode={statusCode}
      buttonProps={{
        copyKey: isEditor
          ? 'EP_JOBS_EMPTYSTATE_CTA'
          : 'EP_JOBS_PUBLIC_EMPTYSTATE_CTA',
        href: isEditor ? JOBMANAGER_URL : XING_JOBS_URL,
      }}
    />
  );
};
